import './SavedTicketPart.less';
import BulbIcon from '@/icons/BulbIcon';
import DeleteIcon from '@/icons/DeleteIcon';
import React from 'react';
import i18n from '@i18n';
import useLocalStorage from 'nike-ui/src/common/hooks/useLocalStorage';

export function BarcodeHeader({ barcode }) {
    if (!barcode) {
        return null;
    }
    return (
        <div className="barcode-section">
            <div
                className="ticket-barcode"
                style={{
                    background: 'url(/barcode?number=' + encodeURIComponent(barcode) + ') no-repeat',
                    backgroundSize: 100 + '%',
                    width: 100 + '%',
                    height: 60 + 'px'
                }}
            />
            <div className="barcode-number">{barcode}</div>
        </div>
    );
}

export function SavedTicketHint() {
    const [closed, setClosed] = useLocalStorage('saved-ticket-hint-closed', false);
    if (closed) {
        return null;
    }
    return (
        <div className="hint-box">
            <div className="hint">
                <div className="bulb">
                    <BulbIcon width={19} height={20} fill={'#000'} opacity={1} />
                </div>
                <p>{i18n('saved-tickets.hint')}</p>
                <div className="close" onClick={() => setClosed(true)}>
                    <DeleteIcon fill="#000000" opacity={0.5} height={14} width={14} />
                </div>
            </div>
        </div>
    );
}
